import { IKebabOption } from '../Kebab.interfaces';
import { KebabOption } from './KebabOption';

export default KebabOption as any as React.StatelessComponent<IKebabOption>;
